



















































































































import { Component, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { MerchantChangeDetail } from '@/libs/api.interfaces';
import numberFormat from '@/libs/numberFormat';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    ScrollbarWrapper,
  },
  methods: {
    numberFormat,
  },
})
export default class MerchantChangeDetailPage extends Vue {
  detail: MerchantChangeDetail = {} as MerchantChangeDetail;
  numberFormat!: (val: string) => string;
  loading = true;

  mounted() {
    this.getDetail();
  }

  async getDetail() {
    try {
      this.loading = true;
      const { data } = await api.get<MerchantChangeDetail>(
        `/disbursement/summary-api/detail/${this.$route.params.client_id}/${this.$route.params.date}`,
      );

      this.detail = data;
      this.loading = false;
    } catch (err) {
      console.error(err);
      const error = err as AxiosError;

      if (err.response) {
        showToast(ToastType.FAILED, `Error ${error.response?.status}`, err.response.data.error.message);
      } else {
        showToast(ToastType.FAILED, 'Error', 'Error fetching the statement detail');
      }
    }
  }

  dateFormat = (time: string) => {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
